import React from 'react';
import { PopupProps } from 'react-map-gl';
import { FlightPopup } from './styles';

export const RealtimeMapTag: React.FC<PopupProps> = ({ children, offset, ...rest }) => {
  const offsetMap = {
    'top-left': [14, 14],
    'top-right': [-14, 14],
    'bottom-left': [14, -14],
    'bottom-right': [-14, -14],
    left: [14, 0],
    right: [-14, 0],
  };
  return (
    <FlightPopup
      closeOnClick={false}
      offset={offset || (offsetMap[rest.anchor] as typeof offset)}
      className={`tooltip-${rest.anchor}`}
      {...rest}>
      {children}
    </FlightPopup>
  );
};
